import { useMutation, useQueryClient } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';

/**
 * Hook to update an email draft
 */
export function useUpdateEmailDraft(onSuccess?: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    ...orpc.communications.emailDrafts.update.mutationOptions(),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['communications', 'emailDrafts'],
      });
      onSuccess?.();
    },
  });
}
